import React from 'react';
import { LocationPage } from './useLocationPage';
import './useLocationPage.css';

// ─── Images ───────────────────────────────────────────────────────────────────
// Swap out any of these for Sarasota-specific shots
import heroImg   from '../images/tampa3.webp';
import bgImg     from '../images/image8.webp';
import slideImg1 from '../images/image121.webp';
import slideImg2 from '../images/image117.webp';
import slideImg3 from '../images/image50.webp';

// ─── Config ───────────────────────────────────────────────────────────────────
const indianRocksBeachConfig = {

  /* ── SEO ────────────────────────────────────────────────────────────────── */
  pageTitle:       'Indian Rocks Beach Tree Service | Sam\'s Tree Service',
  metaDescription: 'Expert tree trimming and removal in Indian Rocks Beach, FL. Sam\'s Tree Service handles dangerous trees safely and professionally.',
  canonicalUrl:    'https://samstreeservice.com/tree_service_indian_rocks_beach',

  /* ── Hero ───────────────────────────────────────────────────────────────── */
  heroHeading: 'Serving Indian Rocks Beach',
  heroImageUrl: heroImg,
  bgImageUrl:   bgImg,

  /* ── Slide images ───────────────────────────────────────────────────────── */
  slideImage1: slideImg1,
  slideImage2: slideImg2,
  slideImage3: slideImg3,

  /* ── Main text panel ────────────────────────────────────────────────────── */
  sectionHeading: 'Professional Tree Service in Indian Rocks Beach Specializing In Dangerous Trees',

  paragraphs: [
    `At <strong>Sam's Tree Service</strong>, we bring experienced, professional tree 
     care to the homes and properties of <strong>Indian Rocks Beach</strong>. This 
     beloved Gulf Coast community has beautiful mature trees throughout its 
     neighborhoods but coastal living means those trees age faster and require 
     more frequent professional attention. Salt exposure, storm winds, and sandy 
     soil all work against root stability and canopy health over time.`,

    `We specialize in <strong>dangerous tree situations on coastal residential 
     properties</strong> storm-damaged limbs, leaning palms near homes and docks, 
     overgrown canopies threatening rooflines and fences, and full removals on the 
     narrow lots that define barrier island living. We work safely, work efficiently, 
     and leave your yard clean.`,

    `<strong>Sam's Tree Service</strong> provides trusted, affordable tree care 
     throughout <strong>Indian Rocks Beach</strong> and the surrounding 
     <strong>North Pinellas Gulf beaches</strong> protecting your property 
     and preserving your landscape through every Florida storm season.`,
  ],
  ctaLabel: 'Get a Free Estimate!',

  /* ── Service buttons (optional — defaults to the 4 standard ones) ────────── */
  // serviceButtons: [
  //   { label: 'Tree Trimming', to: '/tree_trimming' },
  //   { label: 'Tree Removal',  to: '/tree_removal'  },
  //   { label: 'Stump Removal', to: '/stump_removal'  },
  //   { label: 'Debris Hauling',to: '/debris_hauling' },
  // ],

  /* ── Google Map ─────────────────────────────────────────────────────────── */
  mapCity: 'Indian Rocks Beach, FL',
};

// ─── Page ─────────────────────────────────────────────────────────────────────
const Services_IndianRocksBeach = () => <LocationPage config={indianRocksBeachConfig} />;
export default Services_IndianRocksBeach;
